<ion-header class="ion-no-border">
  <ion-toolbar color="light" class="ion-no-border">
    <ion-buttons slot="start">
      <ion-button (click)="return()">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button color="secondary" class="bordered" *ngIf="outlet.yum_points" (click)="explainYumPoints()">
        <ion-icon color="primary" name="ribbon"></ion-icon>
       </ion-button>
      <ion-button color="secondary" class="bordered" (click)="share()">
        <ion-icon color="primary" name="share-social"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content fullscreen="true" slot="fixed">

  <div class="contentHeader">
    <div  class="specialImgCard">
      <img class="specialImg"  [defaultImage]="assetLinksService.noImage" [lazyLoad]="outlet.banner" [errorImage]="assetLinksService.noImage" onerror="this.src='assets/errorimg_ink.png'">
    </div>
  </div>
  <span style="position: absolute;
  top: 4em;
  left: 50%;
  z-index: 1;
  text-align: center;
  transform: translate(-50%, 0px);">
    <ion-avatar style="width: 9em;
    height: 9em;
    border: 0.2em solid var(--ion-color-dark);">
      <img  [defaultImage]="assetLinksService.avatarLoading" [lazyLoad]="outlet.image" [errorImage]="assetLinksService.noImage" onerror="this.src='assets/errorimg_ink.png'">
    </ion-avatar>
  </span>


  <ion-card #content class="outlet-details-card">
    <ion-card-header class="outlet-details-card-header">
      <ion-grid class="outlet-details-card-header-grid" fixed>
        <ion-row >
            <ng-container *ngIf="outlet.name">
              <ion-col class="outlet-details-card-header-grid-left" size="12">
              <ion-card-title>
                <h2>{{outlet.name}} </h2>
              </ion-card-title>
              <ion-card-subtitle>
                {{outlet.address}}
              </ion-card-subtitle>
            </ion-col >
            </ng-container>
            <ng-container *ngIf="!outlet.name">
              <ion-col class="outlet-details-card-header-grid-left" size="12">
              <ion-card-title >
                <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text> 
              </ion-card-title>
              <ion-card-subtitle>
                <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
              </ion-card-subtitle>
            </ion-col >
        
            </ng-container>
            
        </ion-row>
      </ion-grid>
    </ion-card-header>

    <ion-grid style="text-align: center;">
      <ion-row>
        <ion-col>
          <ion-button class="contactInfoButtons" (click)="call()">
            <ion-icon name="call-outline"></ion-icon>
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button (click)="sendMail()" class="contactInfoButtons">
            <ion-icon name="mail-outline"></ion-icon>
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button class="contactInfoButtons" (click)="viewMap()">
            <ion-icon name="location-outline"></ion-icon>
          </ion-button>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-button [disabled]="!shop || !shop.whatsapp" class="contactInfoButtons" (click)="openWhatsapp()">
            <ion-icon name="logo-whatsapp"></ion-icon>
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button [disabled]="!shop || !shop.facebook" class="contactInfoButtons" (click)="openFacebookPage()">
            <ion-icon name="logo-facebook"></ion-icon>
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button [disabled]="!shop || !shop.instagram" class="contactInfoButtons" (click)="openInstaPage()">
            <ion-icon name="logo-instagram"></ion-icon>
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button [disabled]="!shop || !shop.website" class="contactInfoButtons" (click)="openWebsite()">
            <ion-icon name="globe-outline"></ion-icon>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
    
    <ion-card  style="text-align: center;box-shadow: none;">
     
      <ion-accordion-group>
        <ion-accordion value="first">
          <ion-item slot="header" color="light">
            <ion-label>Trading Hours</ion-label> 
            <ion-note [class]="tradingStatus" class="tradingStatus">({{tradingStatus}})</ion-note>
          </ion-item>
          <div class="ion-padding" slot="content">
            <ion-item *ngFor="let day of tradingHours">
              <ion-label *ngIf="!day.activated">
                {{day.abbreviation}} : {{day.from}} - {{day.to}}
              </ion-label>
              <div *ngIf="day.activated" class="timeLeftToday">
                <ion-label *ngIf="day.activated">
                  {{day.abbreviation}} : {{day.from}} - {{day.to}}
                </ion-label>
              </div>
          </ion-item>
          </div>
        </ion-accordion>
      </ion-accordion-group>
      
    </ion-card>
  </ion-card>



  <ion-toolbar  *ngIf="outletWithDealz && outletWithDealz.dealz.length>0">
    <ion-item  mode="ios">
      <ion-thumbnail style="margin: 0.5em;">
        <img [src]="assetLinksService.loyalty_programme_small" />
      </ion-thumbnail>
      <ion-label  >
        <h2>Loyalty Programmes</h2>
        <p>Click the add button to add to your wallet. Click on the card for more info</p>
      </ion-label>
     </ion-item>
     <swiper 
     #swiper 
     [config]="dealzSwiperConfig"
     (swiper)="onSwiper($event)"
     (beforeTransitionStart)="onBeforeTransitionStart($event)">
       <ng-template swiperSlide *ngFor="let deal of outletWithDealz.dealz;" >
        <app-deal-lane-card 
        [deal]="deal"
        [cardHeight]="'15em'"
        [outlet]="outletWithDealz"
        (onWantsToFlip)="slideNext()"
       
        >
        </app-deal-lane-card>
       </ng-template>
   </swiper>
   
  </ion-toolbar>

  <ion-toolbar  *ngIf="stories && stories.length>0">
    <ion-item  mode="ios">
      <ion-thumbnail style="margin: 0.5em;">
        <img [src]="assetLinksService.story_small" />
      </ion-thumbnail>
      <ion-label  >
        <h2>Stories</h2>
        <p>Click a card to read a story</p>
      </ion-label>
     </ion-item>
     <swiper 
     #swiper 
     [config]="storiesSwiperConfig"
     (swiper)="onSwiper($event)"
     (beforeTransitionStart)="onBeforeTransitionStart($event)">
       <ng-template swiperSlide *ngFor="let story of stories;" >
        <app-story-lane-card 
        [story]="story"
        [cardHeight]="'9em'"
        [shop]="shop"
        (onWantsToFlip)="slideNext()"
        >
        </app-story-lane-card>
       </ng-template>
   </swiper>
   
  </ion-toolbar>


    <!-- <ion-toolbar  color="light" >
    <ng-container *ngIf="nearbyShops.length > 0">
      <app-stories-lane
      class="fade-in"
      [shopsWithStories]="nearbyShops"
    >
    </app-stories-lane>
    </ng-container>
   </ion-toolbar>   -->
</ion-content>